<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditDealerHoliday</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>

      <form [formGroup]="addDealerHolidayForm" (ngSubmit)="onSubmit()">
        <div class="card scrollbar">
          <div class="card-content">
            <div class="card-body">
              <div class="form-row">
                <div class="col-6 af-form-group">
                  <label for="typeahead-format" translate>lblSelectDealer
                    <span>:</span> </label>
                  <div class='lbl-info'>
                    <input id="typeahead-format" type="text" formControlName="dealer" class="form-control mb-2"
                      placeholder="Search Dealer" [(ngModel)]="dealerSelected" name="searchDealer"
                      [ngbTypeahead]="search" [resultFormatter]="formatter" (selectItem)="setDealer($event)" [attr.disabled]="true" />
                    <div *ngIf="cpf.dealer.touched && (cpf.dealer.errors?.required)" class="help-block mt-1 text-danger"
                      translate> <em class="ft-alert-circle align-middle" aria-hidden="true" translate></em>
                      lblDealerNameRequired
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="name" translate>lblName
                    <span>:</span> </label>
                  <div class='lbl-info'>
                    <input formControlName="name" class="form-control mb-2" name="name"
                      [(ngModel)]="this.dealerHolidayViewModel.name" placeholder="Enter Name" required>
                    <div *ngIf="cpf.name.touched && (cpf.name.errors?.required)" class="help-block mt-1 text-danger"
                      translate> <em class="ft-alert-circle align-middle" aria-hidden="true" translate></em>
                      lblHolidayNameRequired
                    </div>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="startDate" translate>lblStartDate
                    <span>:</span> </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                      required [dateTime]="false" formControlName="startDate" [disableNextMonthDates]="true"
                      [(ngModel)]="this.dealerHolidayViewModel.startDate" id="txtboxStartDate" name="StartDate"
                      type="text" value="">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="endDate" translate>lblEndDate
                    <span>:</span> </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker formControlName="endDate"
                      [startDate]="'2011/01/01'" required [dateTime]="false" id="txtboxEndDate"
                      [disableNextMonthDates]="true" [(ngModel)]="this.dealerHolidayViewModel.endDate" name="EndDate"
                      type="text" value="">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button class="btn btn-primary btn-lg mr-sm-2" [disabled]="!addDealerHolidayForm.valid"
                aria-label="Center Align" translate>lblSaveChanges</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>